import axios from "axios";
import {JobParamsRequest, JobResponse, JobSharePointRequest} from "../models/jobs.models";

export const jobsService = {
    getJobs: async (): Promise<JobResponse[]> => {
        const response = await axios.get<JobResponse[]>('/jobs');
        return response.data;
    },
    createJob: async (request: Partial<JobParamsRequest>): Promise<number> => {
        const response = await axios.post('/jobs', { ...request});
        return response.data.jobConfigurationId;
    },
    updateJob: async (id: number, request: JobParamsRequest | JobSharePointRequest): Promise<void> => {
        await axios.put(`/jobs/${id}`, { ...request});
    },
    deleteJob: async (id: number): Promise<void> => (
        await axios.delete(`/jobs/${id}`)
    ),
};